export default __webpack_public_path__ + "static/carecredit-banner-4026c11a62711257a7f602e2bf65ffee.webp";